import { AdminAside, Header, Footer } from 'components';
import PropTypes from 'prop-types';
import React from 'react';

import RenderRoutes from 'routes/RenderRoutes';
import { UiHeader, UiMain, UiAside, UiContent } from './AdminPageLayout.style';

/**
 * 管理介面的主要版型
 */

export const AdminPageLayout = ({ routes = [] }) => {
  return (
    <>
      <UiHeader>
        <Header />
      </UiHeader>
      <UiMain>
        <UiAside>
          <AdminAside />
        </UiAside>
        <UiContent>
          <RenderRoutes routes={routes} />
        </UiContent>
      </UiMain>
      <Footer />
    </>
  );
};

AdminPageLayout.propTypes = {
  routes: PropTypes.array
};


